// frontend/src/components/StudentDetails.js

import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import './StudentDetails.css'; // Create and import CSS as needed

const StudentDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { studentNumber } = location.state || {};
  const [student, setStudent] = useState(null);
  const [amount, setAmount] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    if (!studentNumber) {
      navigate('/');
      return;
    }
    console.log("Student",studentNumber)

    const fetchStudentDetails = async () => {
      try {
        // Fetch student details from backend
        // Assuming you have an endpoint like /api/students/:studentNumber
        //const response = await axios.get(`http://localhost:5000/api/students/${studentNumber}`);
        const response = await axios.get(`http://localhost:5000/api/payment/students/${studentNumber}`);

        if (response.data.success) {
          setStudent(response.data.student);
        } else {
          setError(response.data.message || 'Student not found.');
        }
      } catch (err) {
        console.error('Error fetching student details:', err);
        setError('An error occurred while fetching student details.');
      }
    };

    fetchStudentDetails();
  }, [studentNumber, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!amount || isNaN(amount) || Number(amount) <= 0) {
      setError('Please enter a valid amount.');
      return;
    }

    try {
      // Initiate payment by sending data to backend
      const payload = {
        studentNumber: student.studentNumber,
        amount: Number(amount),
      };

      const response = await axios.post('http://localhost:5000/api/payment/initiate', payload);

      if (response.data.success) {
        const { params, signature } = response.data;
        // Navigate to PaymentRedirect with params and signature
        navigate('/redirect', { state: { params, signature } });
      } else {
        setError(response.data.message || 'Failed to initiate payment.');
      }
    } catch (err) {
      console.error('Error initiating payment:', err);
      setError('An error occurred while initiating payment.');
    }
  };

  const handleBack = () => {
    navigate('/');
  };

  if (error && !student) {
    return (
      <div className="form-container">
        <h2>Error</h2>
        <p>{error}</p>
        <button onClick={handleBack} className="button">Go Back</button>
      </div>
    );
  }

  return (
    <div className="form-container">
      <h2>Confirm Student Details</h2>
      {student ? (
        <form onSubmit={handleSubmit}>
          <div className="details-block">
            <p><strong>First Name:</strong> {student.FirstName}</p>
            <p><strong>Last Name:</strong> {student.LastName}</p>
            <p><strong>Student Number:</strong> {student.studentNumber}</p>
          </div>
          <div className="input-block">
            <label htmlFor="amount">Amount (ZM):</label>
            <input
              type="number"
              id="amount"
              name="amount"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              required
              min="1"
              step="0.01"
            />
          </div>
          {error && <p className="error">{error}</p>}
          <div className="button-group">
            <button type="button" onClick={handleBack} className="button">Back</button>
            <button type="submit" className="button">Proceed to Payment</button>
          </div>
        </form>
      ) : (
        <p>Loading student details...</p>
      )}
    </div>
  );
};

export default StudentDetails;
